import { createModel } from "hox";
import { useState } from "react"
import { ICaseDetail, ICaseSearch, IMD5ImgField, ICaseField,ids } from "../caseTypes"
import { caseService } from "../caseService";
import { message } from "antd";
import { TablePaginationConfig } from "antd/lib/table";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISearchPage } from "@/types/AppTypes";
import useGlobalModel, { transPgToPagination } from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { globalPrompt } from "@/components/message";
interface IRestaurantType {
    visible: boolean,
    mode: "add" | "edit" | "look"
}
export const useInternalModel = createModel(function () {
    const { user } = useGlobalModel()

    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //列表数据
    const [dataSource, setDataSource] = useState<ICaseDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<ICaseField>({});
    //分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const initMd5 = {
        "id": "",
        "imgMd5": "",
        "imgTitle": "",
        "connectId": ""
    }
    const [selectedRow, setSelectedRow] = useState<ICaseField[]>([]);
    //新增图片
    const [addFormVal, setAddFormVal] = useState<ICaseDetail>({createUser: user.userName}) //表单的值;
    const [addMd5FormVal, setAddMd5FormVal] = useState<string[]>([]) //图片md5值;
    const [addMd5List, setAddMd5List] = useState<IMD5ImgField[]>([initMd5]) //图片md5值;
    //编辑图片
    const [editFormVal, setEditFormVal] = useState<ICaseDetail>({}) //表单的值;
    const [editMd5FormVal, setEditMd5FormVal] = useState<string[]>([]) //图片md5值;
    const [editMd5List, setEditMd5List] = useState<IMD5ImgField[]>([]) //图片md5值;

    //设置搜索value
    const updateSearchParam = (updateParam: ICaseField) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: ICaseField = searchParam) => {
        const searchParams = {
            ...searchValue,
            type: "domestic",
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await caseService.page(searchParams);
        const { items, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(items);
    }
    //查询一条
    const getDetailEditOne = async (id: string, mode: string) => {
        let { retData } = await caseService.one(id);
        const { list, ...from } = retData;
        setEditFormVal(from);
        setEditMd5List(list as IMD5ImgField[]);
        setEditMd5FormVal(list ? list.map(item => item.imgMd5) as string[] : []);

    }
    //关闭页签清不同状态缓存
    const resetAddCatch = async (type?: string) => {
        setAddFormVal({})
        setAddMd5FormVal([]);
        setAddMd5List([]);
    }
    const resetEditCatch = async (type?: string) => {
        setEditFormVal({});
        setEditMd5FormVal([]);
        setEditMd5List([]);
    }
    //新增国际案例
    const insertDetail = useLockFn(async (params: ICaseField) => {
        let newMd5List = addMd5FormVal.map((item) => {
            return {
                imgMd5: item,
                id: "",
                imgTitle: "",
                honorId: ""
            }
        })
        let { retData } = await caseService.insert({ ...params, createUser: user.userName, list: newMd5List });
        return retData;
    })
    //编辑国际案例
    const editDetail = useLockFn(async (params: ICaseField) => {
        let newMd5List: IMD5ImgField[] = [];
        // console.log(md5FormVal, md5List)
        editMd5FormVal.forEach((formItem, formInd, formArr) => {
            editMd5List.length !== 0 ?editMd5List.forEach((listItem, listInd, listArr) => {
                if (formInd === listInd) {
                    let { imgMd5, ...item } = listItem
                    newMd5List.push({ ...item, imgMd5: formItem })
                } else if (formArr.length > listArr.length) {
                    newMd5List.push({ ...initMd5, imgMd5: formItem })
                }
            }):newMd5List.push({ ...initMd5, imgMd5: formItem })
        })
        let { retData } = await caseService.update({ ...params, updateUser: user.userName, list: newMd5List });
        return retData;
    })
    const onRemove = useLockFn(async (ids:ids ) => {
        let { retData } = await caseService.delete(ids)
        if (retData) {
            loadData();
            globalPrompt("message", { text: "国际案例删除成功", type: "success" })
        }
    })
    return {
        dataSource,
        searchParam,
        pgCfg,
        selectedRowKeys,
        initPgCfg,
        selectedRow,
        addFormVal,
        addMd5FormVal,
        addMd5List,
        editFormVal,
        editMd5FormVal,
        editMd5List,
        setSelectedRowKeys,
        setPgCfg,
        setSearchParam,
        setDataSource,
        updateSearchParam,
        resetSearchParam,
        loadData,
        setSelectedRow,
        insertDetail,
        editDetail,
        onRemove,
        setAddFormVal,
        setAddMd5FormVal,
        setAddMd5List,
        setEditFormVal,
        setEditMd5FormVal,
        setEditMd5List,
        getDetailEditOne,
        resetAddCatch,
        resetEditCatch
    }
})